import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import toast from "react-hot-toast";
import useTranslator from "../../../hooks/useTranslator";

const TotalKgBaggedModal = ({ show, setShow, record, mode, onSave, date, lotNumber }) => {
  const { _t } = useTranslator();

  const initialFormData = {
    lot_number: lotNumber || "",
    cheeks_kg: "",
    strips_kg: "",
    tapita_kg: "",
    strips_separated_kg: "",
    cheeks_separated_kg: "",
    tapita_separated_kg: "",
    date: date || "",
    total_kg:""
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (show) {
      if (record && mode === "edit") {
        setFormData({
          lot_number: record.lot_number || lotNumber || "",
          cheeks_kg: record.cheeks_kg || "",
          strips_kg: record.strips_kg || "",
          tapita_kg: record.tapita_kg || "",
          strips_separated_kg: record.strips_separated_kg || "",
          cheeks_separated_kg: record.cheeks_separated_kg || "",
          tapita_separated_kg: record.tapita_separated_kg || "",
          date: date || "",
          total_kg: record.total_kg || 0
        });
      } else {
        setFormData({
          ...initialFormData,
          lot_number: lotNumber || "",
          date: date || "",
        });
      }
    }
  }, [show, record, mode, date, lotNumber]);

  const handleClose = () => {
    setShow(false);
    setFormData(initialFormData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updatedFormData = { ...prev, [name]: value };
      
      // Auto-calculate total_kg when cheeks_kg, strips_kg, or tapita_kg changes
      if (name === "cheeks_kg" || name === "strips_kg" || name === "tapita_kg") {
        const cheeks = parseFloat(updatedFormData.cheeks_kg) || 0;
        const strips = parseFloat(updatedFormData.strips_kg) || 0;
        const tapita = parseFloat(updatedFormData.tapita_kg) || 0;
        
        updatedFormData.total_kg = cheeks + strips + tapita;
      }
      
      return updatedFormData;
    });
  };

  const handleSubmit = async () => {
    const requiredFields = [
      {
        key: "cheeks_kg",
        label: _t("kg_cheeks", "KG Of Cheeks"),
      },
      {
        key: "strips_kg",
        label: _t("kg_strips", "KG Of Strips"),
      },
      {
        key: "tapita_kg",
        label: _t("kg_tapita", "KG Of Tapita"),
      },
      {
        key: "total_kg",
        label: _t("total_kg", "Total KG"),
      },
    ];

    const emptyField = requiredFields.find(({ key }) => {
      const value = formData[key];
      return value === "" || value === null || value === undefined;
    });

    if (emptyField) {
      return toast.error(
        _t(
          "all_bagged_values_required",
          `Please enter :field before submitting.`,
          { field: emptyField.label }
        )
      );
    }

    // Call the onSave callback with form data
    if (onSave) {
      onSave(formData);
    }
    handleClose();
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "edit"
          ? _t("edit_kg_bagged", "Edit KG Bagged")
          : _t("add_kg_bagged", "Add KG Bagged")
      }
      children={formData}
    >
      <Row className="mb-1">
        <Col lg={12}>
          <InputWithLabel
            label={_t("lot_number", "Lot Number")}
            type="text"
            name="lot_number"
            value={formData.lot_number}
            onChange={handleChange}
            placeholder="Lot Number"
            disabled={true}
          />
        </Col>
      </Row>

      <Row className="">
        <Col lg={6}>
          <InputWithLabel
            label={_t("kg_cheeks", "KG Of Cheeks")}
            type="number"
            name="cheeks_kg"
            value={formData.cheeks_kg}
            onChange={handleChange}
            placeholder={"0"}
            required={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("kg_strips", "KG Of Strips")}
            type="number"
            name="strips_kg"
            value={formData.strips_kg}
            onChange={handleChange}
            placeholder={"0"}
            required={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("kg_tapita", "KG Of Tapita")}
            type="number"
            name="tapita_kg"
            value={formData.tapita_kg}
            onChange={handleChange}
            placeholder={"0"}
            required={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("total_kg", "Total KG")}
            type="number"
            name="total_kg"
            value={formData.total_kg}
            onChange={handleChange}
            placeholder={"0"}
            disabled={true}
            required={true}
          />
        </Col>
      </Row>
      

      <Row className="mt-3">
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default TotalKgBaggedModal;
